module.exports = __webpack_public_path__ + "images/carver_small880c158ad5219b133a4d62c14998b373.png";